import React from 'react';
import { useDisclosure } from '@mantine/hooks';
import { Select, Popover, Text, Stack, Accordion, List, ScrollArea, ActionIcon } from '@mantine/core';
import { Icons } from '../../../../utils/Icons';
import { RISK_INFO } from '../constants';

/**
 * Mantine Select for breach risk classification, with an info popover explaining
 * each risk level's criteria, and an inline description card for the selected level.
 */
const RiskInfoPopover = ({ data, value, onChange, error }) => {
	const [opened, { toggle, close }] = useDisclosure(false);
	const selectedRiskInfo = RISK_INFO.find(r => r.label === data.find(d => d.value === value)?.label);

	return (
		<>
			<div className='d-flex align-items-center gap-1 mb-1'>
				<label className='form-label mb-0'>
					Clasificación de Riesgo <span className='text-danger'>*</span>
				</label>
				<Popover
					opened={opened}
					onClose={close}
					position='right'
					withArrow
					shadow='md'
					width={460}
				>
					<Popover.Target>
						<ActionIcon type='button' onClick={toggle} variant='subtle' color='gray' size='xs'>
							<i className={Icons.info} />
						</ActionIcon>
					</Popover.Target>
					<Popover.Dropdown>
						<ScrollArea.Autosize mah={420}>
							<Accordion radius='sm'>
								{RISK_INFO.map(risk => (
									<Accordion.Item key={risk.label} value={risk.label}>
										<Accordion.Control>
											<Text fw={700} c={risk.color} size='sm'>{risk.label}</Text>
										</Accordion.Control>
										<Accordion.Panel>
											<Stack gap='xs'>
												<Text size='xs'>{risk.description}</Text>
												<Text size='xs' fw={600}>Criterios de clasificación:</Text>
												<List size='xs' spacing={4}>
													{risk.criteria.map((criterion, i) => (
														<List.Item key={i}>{criterion}</List.Item>
													))}
												</List>
											</Stack>
										</Accordion.Panel>
									</Accordion.Item>
								))}
							</Accordion>
						</ScrollArea.Autosize>
					</Popover.Dropdown>
				</Popover>
			</div>
			<Select
				data={data}
				value={value || null}
				onChange={val => onChange(val || '')}
				placeholder='Seleccione clasificación'
				searchable
				clearable
				error={error}
			/>
			{selectedRiskInfo && (
				<div
					className='mt-2 p-2 rounded'
					style={{ borderLeft: `3px solid var(--mantine-color-${selectedRiskInfo.color}-6)`, background: 'var(--mantine-color-default-hover)' }}
				>
					<Text size='xs' c='dimmed'>{selectedRiskInfo.description}</Text>
				</div>
			)}
		</>
	);
};

export default RiskInfoPopover;
